export const URL = process.env.DADATA_PROXY_SUGGEST_FIO;
export const HEADERS = {
    Accept: 'application/json',
    Authorization: `Token ${process.env.DADATA_PROXY_SUGGEST_FIO_TOKEN}`,
};
